import React from 'react';
import { MantineProvider } from '@mantine/core';
import { RouterProvider } from '@tanstack/react-router';
import { routerInstance } from './router';
import { Providers } from './providers'
import { OktaAuthProvider } from './providers/okta-auth-provider';
import '@mantine/core/styles.css';

function App() {
  return (
    <MantineProvider>
      <Providers>
        <OktaAuthProvider>
          <RouterProvider router={routerInstance} />
        </OktaAuthProvider>
      </Providers>
    </MantineProvider>
  );
}

export default App;